import _ from "underscore"
import $ from "jquery"
import messageResource from "../../messageResource"
import UserSelectorUtils from '../../usersSelector/UserSelectorUtils'
import BaseReportParamsStringBuilder from './BaseReportParamsStringBuilder'
import BaseReportFormatUtils from '../FormatUtils'

export default class APReportParamsStringBuilder extends BaseReportParamsStringBuilder {
    constructor({data, dateFormat}) {
        super({data, dateFormat, userFormatter: BaseReportFormatUtils.reportUserFormatterWithoutUsername})

        this.userGroupsFeatureEnabled = data.userGroupsFeatureEnabled
        this.tzGroupsFeatureEnabled = data.tzGroupsFeatureEnabled
    }

    getUserSelectionParamString(userSelection, assignedInfo) {
        return super.getUserSelectionParamString(userSelection, () => this._getAllUsersMessage(assignedInfo))
    }

    _getAllUsersMessage(assignedInfo) {
        if (!_.isUndefined(assignedInfo) && assignedInfo.isShowOnlyAssigned) {
            return messageResource.getMessage("common.report.all_staff.assigned_to_me", [assignedInfo.viewerInfo.formatNameFML()])
        } else {
            return messageResource.getMessage("common.pdf.formatting.all_staff")
        }
    }

    _convertSelectedGroupsToSelectedUsersIfNecessary(users, userSelection) {
        const convertedUsers = UserSelectorUtils.convertSelectedGroupsIntoSelectedUsersIfNecessary(
            this.users,
            userSelection.groupType,
            userSelection.allUsers,
            userSelection.showDisabled,
            userSelection.selectedGroups,
            this.userGroupsFeatureEnabled,
            this.tzGroupsFeatureEnabled)

        return $.merge(users, convertedUsers)
    }

    _getIncludeUserTeamOnlyMessage(users) {
        // doesn't support in AP
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/reportParamsStringBuilder/APReportParamsStringBuilder.js